/**
 * Error code /api/login answers with (HTTP 403) when BotID blocks a request in
 * enforce mode. Shared by the server response and the client mapping so a
 * typo on either side can't silently degrade to the "wrong password" message.
 */
export const BOTID_BLOCKED_ERROR_CODE = 'browser_verification_failed';

export type BotIdProtectedRoute = {
  path: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | '*';
};

/**
 * Routes the BotID client attaches a challenge header to.
 *
 * Every entry here MUST have a matching verifyNotBot() call in its route
 * handler, and every handler calling verifyNotBot() MUST be listed here —
 * a protected handler whose path is missing from this list receives no
 * challenge header and classifies every real user as a bot.
 */
export const BOTID_PROTECTED_ROUTES: BotIdProtectedRoute[] = [
  { path: '/api/login', method: 'POST' },
  { path: '/api/stripe/attach/payment_method', method: 'POST' },
  { path: '/api/signup/setup-intent', method: 'POST' },
  { path: '/api/stripe/invoices/create', method: 'POST' },
  { path: '/api/stripe/invoices/pay', method: 'POST' },
  { path: '/api/stripe/invoices/restore', method: 'POST' },
  { path: '/api/revolve/order-submit', method: 'POST' },
  { path: '/api/revolve/order-cancel', method: 'POST' }
];
